const features = [
  {
    icon: 'ri-user-heart-line',
    title: 'Atendimento Humanizado',
    description:
      'Nosso foco é no cliente e aqui você não é tratado como número. Escutamos sua história com empatia e explicamos cada etapa com clareza e cuidado — sem juridiquês.',
  },
  {
    icon: 'ri-award-line',
    title: 'Especialização Técnica',
    description:
      'Mais de 15 anos focados exclusivamente em Direito Previdenciário. Conhecemos profundamente as regras do INSS e resolvemos situações complexas com precisão.',
  },
  {
    icon: 'ri-discuss-line',
    title: 'Acesso Direto',
    description:
      'Você fala direto com quem cuida do seu processo. Sem intermediários, sem rodeios — total transparência do início ao fim.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Atendimento Nacional',
    description:
      'Estrutura física no RS e operação virtual robusta para atender clientes em todo o Brasil com agilidade e segurança.',
  },
];

export default function WhyChooseSection() {
  return (
    <section id="diferenciais" className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-8">

        {/* Header */}
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-6 h-px bg-brand-gold" />
            <span className="font-inter text-xs font-medium text-brand-gold uppercase tracking-[0.18em]">
              Nossos Diferenciais
            </span>
          </div>
          <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-6">
            <h2 className="font-cormorant text-4xl lg:text-5xl font-semibold text-brand-dark leading-tight">
              Por que escolher
              <br />
              <span className="italic">Ariani Zanardo</span>
            </h2>
            <p className="font-inter text-sm text-brand-muted leading-relaxed max-w-sm">
              <span className="font-semibold">Combinamos expertise técnica</span> com atendimento genuinamente humano.
              Resolver uma questão previdenciária vai além do jurídico — é sobre
              <span className="font-semibold"> dignidade e qualidade de vida</span>.
            </p>
          </div>
        </div>

        {/* Features grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8">
          {features.map((feature, i) => (
            <div
              key={i}
              className="group border border-brand-border rounded-xl p-8 hover:border-brand-gold/40 hover:bg-brand-warm transition-all duration-300"
            >
              {/* Icon */}
              <div className="w-12 h-12 flex items-center justify-center bg-brand-cream rounded-lg mb-6 group-hover:bg-brand-gold/10 transition-colors duration-300">
                <i className={`${feature.icon} text-brand-gold text-xl`} />
              </div>

              {/* Number */}
              <p className="font-cormorant text-4xl font-semibold text-brand-border mb-4 group-hover:text-brand-gold/30 transition-colors duration-300">
                0{i + 1}
              </p>

              <h3 className="font-playfair text-xl font-semibold text-brand-dark mb-3">
                {feature.title}
              </h3>
              <p className="font-inter text-sm text-brand-muted leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Divider with quote */}
        <div className="mt-16 pt-12 border-t border-brand-border flex flex-col md:flex-row items-center gap-6">
          <div className="w-10 h-10 flex items-center justify-center bg-brand-cream rounded-full flex-shrink-0">
            <i className="ri-double-quotes-l text-brand-gold text-lg" />
          </div>
          <blockquote className="font-cormorant text-xl lg:text-2xl italic text-brand-charcoal leading-relaxed text-center md:text-left flex-1">
            "Cada benefício conquistado representa uma vida que volta a ter segurança e dignidade."
          </blockquote>
          <div className="hidden md:block flex-shrink-0">
            <p className="font-inter text-xs text-brand-muted whitespace-nowrap">
              — Ariani Zanardo
            </p>
          </div>
        </div>

        {/* WhatsApp CTA */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 py-8 px-8 bg-brand-cream rounded-xl border border-brand-border">
          <div className="text-center sm:text-left">
            <p className="font-playfair font-semibold text-brand-dark text-base mb-1">
              Quer saber se você tem direito a um benefício?
            </p>
            <p className="font-inter text-xs text-brand-muted">
              Envie uma mensagem e receba orientação especializada.
            </p>
          </div>
          <a
            href="https://api.whatsapp.com/send?phone=5551996057679&text=Ol%C3%A1,%20vim%20do%20seu%20site%20e%20gostaria%20de%20falar%20com%20um%20advogado."
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20ba5a] text-white font-inter font-semibold text-sm px-7 py-3.5 rounded-md transition-all duration-200 flex-shrink-0"
          >
            <i className="ri-whatsapp-line text-base" />
            Falar pelo WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}